import './App.css';
import './styles/accessibility.css';
import AllRoutes from './routes/allRoutes';
import { useEffect, useCallback } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { TenantProvider } from './context/TenantContext';
import SEOHead from './components/SEOHead';
import useIdleTimer from './hooks/useIdleTimer';
import axios from 'axios';
import logger from './utils/logger';

// Setup global axios interceptor to add tenant ID to all requests
axios.interceptors.request.use(
  (config) => {
    // Get tenant ID from window or localStorage
    const tenantId = window.__TENANT_ID__ || localStorage.getItem('dev_tenant_id');

    if (tenantId) {
      config.headers['X-Tenant-ID'] = tenantId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function App() {
  const currentVersion = "1.0.3";

  const handleIdle = useCallback(() => {
    sessionStorage.clear();
    localStorage.removeItem('formData');
    window.location.href = window.location.origin + window.location.search;
  }, []);

  const { showWarning, remainingSeconds, reset } = useIdleTimer({ onIdle: handleIdle });

  useEffect(() => {
    fetch('/meta.json', { cache: "no-cache" })
      .then((res) => res.json())
      .then((meta) => {
        if (meta.version !== currentVersion) {
          window.location.reload(true);
        }
      })
      .catch((err) => {
        logger.warn("Version check failed:", err);
      });
  }, []);

  return (
    <HelmetProvider>
    <TenantProvider>
      <SEOHead appType="client" />
      <div className="App">
        <AllRoutes />
      </div>
      {showWarning && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', zIndex: 9999,
        }}>
          <div style={{
            background: '#fff', borderRadius: 14, padding: '32px 40px', textAlign: 'center',
            maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>&#9200;</div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>
              Session Expiring
            </h2>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 20 }}>
              Your session will expire in <strong style={{ color: '#dc2626' }}>{remainingSeconds}s</strong> due to inactivity.
            </p>
            <button
              onClick={reset}
              style={{
                padding: '12px 28px', background: '#3B82F6', color: '#fff',
                border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer',
              }}
            >
              Stay Active
            </button>
          </div>
        </div>
      )}
    </TenantProvider>
    </HelmetProvider>
  );
}

export default App;
